import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { addIcons } from 'ionicons';
import {
  logOutOutline,
  closeCircleOutline,
  informationCircleOutline,
  alertCircleOutline,
  checkmarkCircleOutline
} from 'ionicons/icons';

// Register icons with kebab-case keys (only icons used in admin app)
addIcons({
  'log-out-outline': logOutOutline,
  'close-circle-outline': closeCircleOutline, // from shared dismissable-alert
  'information-circle-outline': informationCircleOutline, // from shared dismissable-alert + getUpdateMessageIcon
  'alert-circle-outline': alertCircleOutline, // from getUpdateMessageIcon
  'checkmark-circle-outline': checkmarkCircleOutline // from getUpdateMessageIcon
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
